import React from "react";
import "./app/styles/index.css";

import { createRoot } from "react-dom/client";

import App from "~app/app";
import { PROJECT_CODE } from "~app/constants";
import { Tracing } from "~app/tracing";

async function main() {
  try {
    Tracing.init(PROJECT_CODE);
    const container = document.getElementById("root");
    if (!container) {
      throw new Error("Root element not found");
    }
    const root = createRoot(container);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } catch (error) {
    console.error("Unable to boot the application", error);
    Tracing.capture(error);
  }
}

main();
